// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"478":"1a25d763","518":"1a25d763","634":"1a25d763","716":"093b22e6","869":"32d2e075"}[chunkId] + ".chunk.css";
};